import styles from "./blockFour.module.scss";
import { useEffect, useState } from "react";
import Image from "next/image";
import PromptInfo from "../promptInfo/promptInfo";

export default function BlockFour({ data }) {
	const imagePacks = data.Images;
	const [activeImagePack, setActiveImagePack] = useState(imagePacks[0]);

	useEffect(
		() => {
			if (activeImagePack.id !== imagePacks[0].id) setActiveImagePack(imagePacks[0]);
		},
		//eslint-disable-next-line react-hooks/exhaustive-deps
		[imagePacks]
	);

	return (
		<section className={styles.section}>
			<h2 className={styles.title}>{data.Title}</h2>
			{imagePacks.length > 1 && (
				<div className={styles.menu}>
					{imagePacks.map((item) => (
						<button key={item.id} className={`${styles.menuBtn} ${item.id === activeImagePack.id ? styles.active : ""}`} onClick={() => setActiveImagePack(item)}>
							{item.Title}
						</button>
					))}
				</div>
			)}

			<div className={styles.imgWrapper}>
				{activeImagePack.Images.data.map(({ id, attributes }, index) => {
					return (
						<div key={id} className={styles[`img${index + 1}`]}>
							<Image src={attributes.url} alt={attributes.alternativeText} width={attributes.width} height={attributes.height} loading="lazy" unoptimized={true} />
							{attributes.caption?.includes("prompt: ") && (<PromptInfo prompt={attributes.caption.replace("prompt: ", "")} />)}
						</div>
					);
				})}
			</div>
		</section>
	);
}
